import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { environment } from '../../../../environments/environment';
import { toSignal } from '@angular/core/rxjs-interop';
import { NetworkProvider, NetworkStatus } from '../../providers/network/network';

@Component({
  selector: 'feedback',
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
})
export class FeedbackComponent {
  private readonly networkProvider = inject(NetworkProvider);
  private readonly networkStatus = toSignal(this.networkProvider.networkStatusSubject);
  readonly isOnline = computed(() => this.networkStatus() === NetworkStatus.ONLINE);

  callHotline() {
    window.location.href = `tel:${environment.hotlineNumber}`;
  }

  openSupportChat() {
    window.open(environment.supportChatUrl, '_blank');
  }
}
